import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';
import 'rxjs/add/operator/map';

import { Globals } from '../providers/globals';
import { HttpHelper } from '../helpers/httpHelper';
import { Storage } from '@ionic/storage';

import { ConsumerBusinessHandlerProvider } from '../providers/consumer-business-handler';

@Injectable()
export class BusinessProductPaymentManagerHandler {
 	url: any;
 	token: any;
  	businessId: any = 0; 
  	invoice: any;
  	
	constructor(
		public http: Http,
		public globals: Globals,
        public storage: Storage,
        public httpHelper: HttpHelper,
        public consumerBusinessHandlerProvider: ConsumerBusinessHandlerProvider,
	){
	}

	getUser(params, cb){	
	  	this.url = this.globals.dataUrl + 'businessProductPayment/business/' + params.businessId + '/user/' + params.userId + '/device/' + params.deviceId;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token
				
		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getBusinessUser(cb){	
	  	this.url = this.globals.dataUrl + 'businessProductPayment/businessUser';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getCategories(params){	
  		let url = this.globals.dataUrl + 'businessProductPayment/categories';

  		let id = 	(this.consumerBusinessHandlerProvider.business) 
	  				? 
	  				"/" + this.consumerBusinessHandlerProvider.business.Id
	  				:
	  				"";

	  	this.url = url + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getProducts(params){	
  		let url = this.globals.dataUrl + 'businessProductPayment/subCategories';

  		let id = 	(this.consumerBusinessHandlerProvider.business) 
	  				? 
	  				"/" + this.consumerBusinessHandlerProvider.business.Id
	  				:
	  				"";

	  	this.url = url + id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getProductsBySubCategory(params){	
  		let id = 	(this.consumerBusinessHandlerProvider.business) 
	  				? 
	  				"/business/" + this.consumerBusinessHandlerProvider.business.Id
	  				:
	  				"";

	  	this.url = this.globals.dataUrl + 'businessProductPayment' +
	  									  '/subcategory/' + params.subcategoryId + 
	  									  id +
	                                      '/page/' + params.page +
	                                      '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getModifiersByProductId(params){	
  		this.url = this.globals.dataUrl + 'businessProductPayment/modifiers/' + params.id;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	getPaymentTypes(cb){	
  		var url = this.globals.dataUrl + 'businessProductPayment/whiskey/' + this.globals.whiskeyId + '/paymentTypes';

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof cb == "function") cb(res.Data);
		    });   
    	})
  	}

  	getCashierProducts(params){	
	  	this.url = this.globals.dataUrl + 'businessProductPayment' + 
	                                      '/page/' + params.page +
	                                      '/size/' + params.size;

    	this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http.get(
		        this.url,
		        this.httpHelper.configOptionsWithToken(loginData.access_token)
		    )
		    .map(res => res.json())
		    .subscribe(res => {
		          if(typeof params.cb == "function") params.cb(res.Data);
		    });   
    	})
  	}

  	debitConsumer(params){
		return new Promise( (resolve, reject) => {
			this.url = this.globals.dataUrl + 'businessProductPayment/debit/' + params.BusinessId + 
											  '/user/' + params.UserId;

			this.storage.get('loginData').then((loginData) => {
				this.http.post(
					this.url,
					params,
					this.httpHelper.configOptionsWithToken(loginData.access_token)
				)
				.map(res=>res.json())
				.subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
				);
			});
		});       
	}	

	searchProducts(params){  
	    this.url = this.globals.dataUrl + 'businessProductPayment/search/'+ params.businessId  +                                   
	                                      '/page/' + params.page  +
	                                      '/size/' + params.size  +
	                                      '?term=' + params.term;

	    this.storage.get('loginData').then((loginData) => {
			this.token = loginData.access_token

			this.http.get(
				this.url,
				this.httpHelper.configOptionsWithToken(loginData.access_token)
			)
			.map(res => res.json())
			.subscribe(res => {
				if(params.cb) params.cb(res.Data);
			});   
	    })
  	}    

  	searchOrders(params){  
	    this.url = this.globals.dataUrl + 'businessProductInvoice/search/page/' + params.page  +
	                                      '/size/' + params.size  +
	                                      '?term=' + params.term;

	    this.storage.get('loginData').then((loginData) => {
			this.token = loginData.access_token

			this.http.get(
				this.url,
				this.httpHelper.configOptionsWithToken(loginData.access_token)
			)
			.map(res => res.json())
			.subscribe(res => {
				if(params.cb) params.cb(res.Data);
			});   
	    })
  	}    

  	getOpenOrders(params){	
		return new Promise( (resolve, reject) => {
		  	this.url = this.globals.dataUrl + 'businessProductPayment/invoices' + 
		                                      '/page/' + params.page +
		                                      '/size/' + params.size;

			this.storage.get('loginData').then((loginData) => {
			    this.http.get(
			        this.url,
			        this.httpHelper.configOptionsWithToken(loginData.access_token)
			    )
			    .map(res => res.json())
			    .subscribe(
					data => {
						resolve(data);
					},
					err => {reject(err)}
			   	);  
			});
		});    	
  	}

  	redeem(params){
	    this.url = this.globals.dataUrl + 'businessProductPayment/redeem/' + params.invoiceId;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}

	void(params){
	    this.url = this.globals.dataUrl + 'businessProductPayment/void/' + params.Id;

	    this.storage.get('loginData').then((loginData) => {
	      	this.token = loginData.access_token

		    this.http
		    .put(
		      this.url, 
		      params, 
		      this.httpHelper.configOptionsWithToken(this.token)
		    )
		    .map(res => res.json())
		    .subscribe(response => {
		        if(typeof params.cb == "function") params.cb(response);
		    });  
		})           
	}
}



// WEBPACK FOOTER //
// ./src/providers/business-product-payment-handler.ts